/** The site's canonical mask, also copied unchanged into packaged wallet apps. */
export function StcLogo({ className }: { className?: string }) {
  return <img className={className} src={`${import.meta.env.BASE_URL}stc-mask-logo.png`} alt="" aria-hidden="true" />;
}
